import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="seats"
export default class extends Controller {
    static targets = ["counter", "decrement", "increment"]

    // Connects to data-action="click->seats#decrement"
    decrement() {
        const value = this.counterTarget.value == "" ? 1 : parseInt(this.counterTarget.value, 10)
        if (value > 1) {
            this.counterTarget.value = value - 1
        }
    }

    // Connects to data-action="click->seats#increment"
    increment() {
        const value = this.counterTarget.value == "" ? 1 : parseInt(this.counterTarget.value, 10)
        this.counterTarget.value = value + 1
    }
}
